import React from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, Divider, Tooltip, Avatar } from '@mui/material';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Row, Col, Space } from 'antd';
import Icon from '@mui/material/Icon';
import { TextsmsOutlined, TimelineRounded, ArchitectureRounded, DesignServicesRounded } from "@mui/icons-material";


const AnnotationMenu = ({ onSelectAnnotation }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuClick = (value) => {
    onSelectAnnotation(value);
    setAnchorEl(null);
  };

  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const WrapItem = ({ title, value, icon }) => {
    return (
      <Tooltip title={title}>
        <MenuItem onClick={() => handleMenuClick(value)}>
              <Button variant="text" size={'large'} color="primary">
                {icon}
              </Button>
        </MenuItem>
      </Tooltip>
    );
  };

  return (
    <div>
      <ButtonGroup>
         <Tooltip title={'Add Label to Chart'}>
              <Button variant={'text'} color={'primary'} size={'small'} onClick={()=>handleMenuClick('label')}>
                  <TextsmsOutlined/>
              </Button>
         </Tooltip>
          <Tooltip title={'Add Line Segment to Chart'}>
          <Button variant={'text'} color={'primary'} size={'small'} onClick={()=>handleMenuClick('lineSegment')}>
                <TimelineRounded/>
          </Button>
          </Tooltip>
          <Tooltip title={'More Annotations. Click to Show Menu'}>
              <Button
                size={'small'}
                variant="text"
                color="primary"
                onClick={handleButtonClick}
              >
                  <DesignServicesRounded/>
              </Button>
          </Tooltip>
      </ButtonGroup>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <Row>
          <Col span={12}>
            <Space direction="vertical">
              <WrapItem title="Vertical Line" value="verticalLine" icon={<Avatar src={'https://storage.googleapis.com/finiat-web-static-resources/chartIcons/vertical-infinity.png'} />} />
              <WrapItem title="Vertical Range" value="verticalRange" icon={<Avatar src={'https://storage.googleapis.com/finiat-web-static-resources/chartIcons/vertical-range.png'} />} />
                <WrapItem title="Rectangle" value="rectangle" icon={<Avatar src={'https://storage.googleapis.com/finiat-web-static-resources/chartIcons/square.png'} />} />

            </Space>
          </Col>
          <Col span={12}>
            <Space direction="vertical">
              <WrapItem title="Horizontal Line" value="horizontalLine" icon={<Avatar src={'https://storage.googleapis.com/finiat-web-static-resources/chartIcons/horizontal-infinity.png'} />} />
              <WrapItem title="Horizontal Range" value="horizontalRange" icon={<Avatar src={'https://storage.googleapis.com/finiat-web-static-resources/chartIcons/horizontal-range.png'} />} />
              <WrapItem title="Ellipse" value="ellipse" icon={<Avatar src={'https://storage.googleapis.com/finiat-web-static-resources/chartIcons/ellipse.png'} />} />
            </Space>
          </Col>
        </Row>
      </Menu>
    </div>
  );
};

export default AnnotationMenu;
